import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterHide",
})
export class EdpFilterHidePipe implements PipeTransform {
    transform(items: Array<any>) {
        return items.filter(i => i.hide !== true);
    }
}
